import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '../../atoms/Button';

export interface AccessDeniedModalContentProps {
  message?: string;
  requiredRoles?: string[];
  onClose: () => void;
}

export const AccessDeniedModalContent = ({
  message = 'Bu işlem için gerekli yetkilere sahip değilsiniz.',
  requiredRoles = [],
  onClose,
}: AccessDeniedModalContentProps) => {
  return (
    <div className="text-center py-6">
      <div className="mb-4 flex justify-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
          <AlertCircle className="w-8 h-8 text-red-600" />
        </div>
      </div>
      <h3 className="text-xl font-bold text-gray-800 mb-2">Erişim Reddedildi</h3>
      <p className="text-gray-600 mb-4">{message}</p>
      {requiredRoles.length > 0 && (
        <p className="text-sm text-gray-500 mb-6">
          Gerekli roller: <span className="font-semibold">{requiredRoles.join(', ')}</span>
        </p>
      )}
      <Button
        variant="primary"
        onClick={onClose}
        className="w-full sm:w-auto"
      >
        Tamam
      </Button>
    </div>
  );
};
